import './chunk-851d1b8f.js';
import './chunk-10ce22e9.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { F as Field } from './chunk-a86155fc.js';
export { F as BField } from './chunk-a86155fc.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Field);
  }
};
use(Plugin);

export default Plugin;
